import { initializeApp } from 'firebase/app';
import { getFirestore, collection } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCrBNlFBAtlE-mar_DKJrgjJxVRqbOYumo",
  authDomain: "lista-de-precios-6f44f.firebaseapp.com",
  projectId: "lista-de-precios-6f44f",
  storageBucket: "lista-de-precios-6f44f.firebaseapp.com",
  messagingSenderId: "913881951062",
  appId: "1:913881951062:web:ee7cb17ef643c6360244f7"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Collections
export const productsCollection = collection(db, 'products');
export const laboratoriesCollection = collection(db, 'laboratories');
export const productLaboratoriesCollection = collection(db, 'product_laboratories');
export const priceHistoryCollection = collection(db, 'price_history');
export const categoriesCollection = collection(db, 'categories');
export const configCollection = collection(db, 'configurations');
export const metadataCollection = collection(db, 'metadata');

// Collection names as constants
export const COLLECTIONS = {
  PRODUCTS: 'products',
  LABORATORIES: 'laboratories',
  PRODUCT_LABORATORIES: 'product_laboratories',
  PRICE_HISTORY: 'price_history',
  CATEGORIES: 'categories',
  CONFIGURATIONS: 'configurations',
  METADATA: 'metadata'
} as const;

// Storage keys
export const STORAGE_KEYS = {
  PRODUCTS: 'cached_products',
  LABORATORIES: 'cached_laboratories',
  CATEGORIES: 'cached_categories',
  CONFIGURATIONS: 'cached_configurations',
  LAST_SYNC: 'last_sync',
  METADATA: 'metadata'
} as const;